const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/general/tags/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireAdmin } from '@/Router';
import { type SiteSettings_Fragment$data } from '@/graphql/queries/SiteSettings.query';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dash/settings/general/tags/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad: () => {
    requireAdmin({
      to: '/dash/catalog'
    });
  }
});
type SiteSettings = Partial<SiteSettings_Fragment$data>['siteSettings'];